import { gql } from '@apollo/client';

export const GET_PICKUP_ROUTES = gql`
  query GetPickupRoutes($filter: PickupRouteFilterInput) {
    getPickupRoutesByFilter(filter: $filter) {
      id
      routeName
      warehouseId
      zipcodesListJson
      driverId
      createdAt
      updatedAt
      isDeleted
    }
  }
`;

export const GET_PICKUP_ROUTES_BY_WAREHOUSE = gql`
  query GetPickupRoutesByWarehouse($warehouseId: Long!) {
    getPickupRoutesByWarehouseId(warehouseId: $warehouseId) {
      id
      routeName
      warehouseId
      zipcodesListJson
      driverId
      createdAt
      updatedAt
      isDeleted
    }
  }
`;

export const GET_PICKUP_ROUTE_WITH_DRIVER_INFO = gql`
  query GetPickupRouteWithDriverInfo($id: Long!) {
    getPickupRouteWithDriverInfoById(id: $id) {
      id
      routeName
      warehouseId
      zipcodesListJson
      driverId
      driverName
      vehicleId
      vehicleModelId
      vehicleTypeId
      vehicleTypeName
      zipcodeCount
      createdAt
      updatedAt
    }
  }
`;

export const COUNT_PICKUP_ROUTES = gql`
  query CountPickupRoutes($filter: PickupRouteFilterInput) {
    countPickupRoutesByFilter(filter: $filter)
  }
`;

export const GET_PICKUP_ROUTES_WITH_VEHICLE_INFO = gql`
  query GetPickupRoutesWithVehicleInfo($warehouseId: Long!, $pickupDate: String!) {
    getPickupRoutesWithVehicleInfoByWarehouseId(warehouseId: $warehouseId, pickupDate: $pickupDate) {
      id
      routeName
      warehouseId
      zipcodesListJson
      driverId
      driverName
      vehicleId
      vehicleModelId
      vehicleNumber
      licensePlate
      vehicleDisplayName
      vehicleModelName
      vehicleTypeId
      vehicleTypeName
      undispatchedAppointmentsCount
      totalParcelsCount
      zipcodeCount
      createdAt
      updatedAt
    }
  }
`;
